import {
  CreateReconciliationReq,
  CreateReconciliationRes,
  GetReconciliationReq,
  GetReconciliationRes,
  ImportAndValidateStatementReq,
  ImportAndValidateStatementRes,
  ListAccountsAndReconciliationsReq,
  ListAccountsAndReconciliationsRes,
  PrintReconciliationPDFReq,
  PrintReconciliationPDFRes,
  VoidReconciliationReq,
  VoidReconciliationRes,
} from "gen/api/bankreconciliation/service_pb"
import { BankReconciliationServiceClient } from "gen/api/bankreconciliation/service_pb.client"

import { transport, apiSlice } from "./apiSlice"

const client = new BankReconciliationServiceClient(transport)

export const listAccountsAndReconciliations =
  "list-accounts-and-reconciliations"

export const reconciliationApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["Reconciliation", listAccountsAndReconciliations],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createReconciliation: builder.mutation<
        CreateReconciliationRes,
        CreateReconciliationReq
      >({
        query: (r) => client.createReconciliation(r),
        invalidatesTags: ["Reconciliation", listAccountsAndReconciliations],
      }),
      importAndValidateStatement: builder.mutation<
        ImportAndValidateStatementRes,
        ImportAndValidateStatementReq
      >({
        query: (r) => client.importAndValidateStatement(r),
      }),
      listAccountsAndReconciliations: builder.query<
        ListAccountsAndReconciliationsRes,
        ListAccountsAndReconciliationsReq
      >({
        query: (r) => client.listAccountsAndReconciliations(r),
        providesTags: ["Reconciliation", listAccountsAndReconciliations],
      }),
      getReconciliation: builder.query<
        GetReconciliationRes,
        GetReconciliationReq
      >({
        query: (r) => client.getReconciliation(r),
        providesTags: ["Reconciliation"],
      }),
      printReconciliationPDF: builder.query<
        PrintReconciliationPDFRes,
        PrintReconciliationPDFReq
      >({
        query: (r) => client.printReconciliationPDF(r),
        providesTags: ["Reconciliation"],
      }),
      voidReconciliation: builder.mutation<
        VoidReconciliationRes,
        VoidReconciliationReq
      >({
        query: (r) => client.voidReconciliation(r),
        invalidatesTags: ["Reconciliation"],
      }),
    }),
  })

export const {
  useCreateReconciliationMutation,
  useImportAndValidateStatementMutation,
  useListAccountsAndReconciliationsQuery,
  useGetReconciliationQuery,
  useLazyPrintReconciliationPDFQuery,
  useVoidReconciliationMutation,
} = reconciliationApiSlice
